import { render, staticRenderFns } from "./IconAddColBefore.vue?vue&type=template&id=d54f4590"
import script from "./IconAddColBefore.vue?vue&type=script&lang=js"
export * from "./IconAddColBefore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports